import { Dialog } from 'quasar'
import { setCurrentSessionIndex } from './sessionsHelper'
import ChooseSessionDialog from '../../components/ChooseSessionDialog'

export function chooseSessionWithDialog () {
  Dialog.create({
    component: ChooseSessionDialog
  }).onOk((result) => {
    if (result.index === -1) return
    setCurrentSessionIndex(result.index)
  }).onCancel(() => {
    console.log('Cancel')
  }).onDismiss(() => {
    console.log('Called on OK or Cancel')
  })
}
